<template>
	<base-layout>
		<template v-slot:header>
			Privacy and Cookies Policy
		</template>
		<template v-slot:main>
			<div class='text-sm space-y-6'>
				
				<div>
					<h2 class="text-lg font-bold text-gray-800 mb-3">1. Collection and Usage of Information</h2>
					<div class="space-y-2">
						<p>1.1 The Broker Site collects personal information when you apply for a membership account on The Broker Site, and when you access certain sections on The Broker Site.</p>
						<p>1.2 When you apply for a membership on The Broker Site, we ask for your personal and corporate information.</p>
						<p>1.3 Once you have submitted your application to The Broker Site, and when you access certain sections on The Broker Site, you are not anonymous to us.</p>
						<p>1.4 The Broker Site also automatically receives data from your browser, including your IP Address, The Broker Site cookies, and the page you requested.</p>
						<p>1.5 The Broker Site uses this information to:</p>
						<ul class="ml-6 space-y-1">
							<li>• Identify you in restricted areas on The Broker Site;</li>
							<li>• Log statistics for the usage of The Broker Site;</li>
							<li>• Contact you when questions and/or problems occur;</li>
							<li>• Inform you of promotions.</li>
						</ul>
					</div>
				</div>

				<div>
					<h2 class="text-lg font-bold text-gray-800 mb-3">2. Sharing and Disclosure of Information</h2>
					<div class="space-y-2">
						<p>2.1 The Broker Site will not sell or rent your personal information to anyone.</p>
						<p>2.2 The Broker Site may send personal information about you to others when:</p>
						<ul class="ml-6 space-y-1">
							<li>• We have your consent to do so;</li>
							<li>• We need to share your information to provide the product or service you have requested;</li>
							<li>• We respond to subpoenas, court orders or legal processes;</li>
							<li>• We find that your actions on The Broker Site violate any of our usage guidelines for The Broker Site.</li>
						</ul>
					</div>
				</div>

				<div>
					<h2 class="text-lg font-bold text-gray-800 mb-3">3. Cookies</h2>
					<div class="space-y-2">
						<p>3.1 The Broker Site may set and access The Broker Site cookies on your computer.</p>
						<p>3.2 Advertisers or other companies do not have access to The Broker Site's cookies.</p>
						<p>3.3 Cookies are used for identification purposes in restricted areas on The Broker Site.</p>
					</div>
				</div>

				<div>
					<h2 class="text-lg font-bold text-gray-800 mb-3">4. Accessing and Modifying Personal Information</h2>
					<div class="space-y-2">
						<p>4.1 The Broker Site gives you the ability to edit your TBS Membership Account Information and preferences at any time.</p>
					</div>
				</div>

				<div>
					<h2 class="text-lg font-bold text-gray-800 mb-3">5. Security</h2>
					<div class="space-y-2">
						<p>5.1 Your TBS Membership Account Information is password-protected for your privacy and security.</p>
					</div>
				</div>

				<div>
					<h2 class="text-lg font-bold text-gray-800 mb-3">6. Changes to this Privacy and Cookies Policy</h2>
					<div class="space-y-2">
						<p>6.1 The Broker Site may amend this policy from time to time.</p>
						<p>6.2 If we make any substantial changes in the way we use your personal information we will notify you by posting a prominent announcement on our pages.</p>
					</div>
				</div>

			</div>
		</template>
	</base-layout>
</template>

<script>
import BaseLayout from '@/components/BaseLayout.vue'

export default {
  name: 'Privacy',
  components: {
    BaseLayout
  }
}
</script>